<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex offset-md1 md10 xs12 px-2>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>{{ $tc('models.role', 2) }}</v-toolbar-title>
            <v-spacer />
            <v-btn v-if="id" icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn
              v-if="
                hasPermission('ASSIGN_ROLE') ||
                hasPermission('ASSIGN_ROLE_PLAYER')
              "
              flat
              @click="openForm()"
            >
              {{ $t('action.buttons.new') }}
            </v-btn>
          </v-toolbar>
          <v-toolbar card flat dense color="white">
            <v-text-field
              v-model="match"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="formatUserRoles"
              disable-initial-sort
              :search="match"
              :loading="loading"
              :rows-per-page-items="[8]"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.role }}</td>
                <td>
                  <template v-for="(object, index) of props.item.objects">
                    <v-list-tile
                      :key="object._id"
                      avatar
                      ripple
                      class="py-2 role-item"
                    >
                      <v-list-tile-avatar
                        v-if="object.img || object.logo || object.photo"
                      >
                        <img :src="object.img || object.logo || object.photo" />
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="body-1">
                          <span>
                            {{ object.name }}
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="object.categoryName"
                          class="caption primary--text text--lighten-1 text-truncate"
                        >
                          {{ object.categoryName.join(' - ') }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action v-if="object.teams">
                        <template v-for="team of object.teams">
                          <v-list-tile :key="team._id" avatar ripple>
                            <v-list-tile-avatar v-if="team.logo">
                              <img :src="team.logo" />
                            </v-list-tile-avatar>
                            <v-list-tile-content class="caption">
                              <v-list-tile-title>
                                <span> {{ team.name }}</span>
                              </v-list-tile-title>
                              <v-list-tile-sub-title
                                class="caption primary--text text--lighten-1 text-truncate text-no-wrap"
                              >
                                {{ team.categoryName.join(' - ') }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="object._id + index" />
                  </template>
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.confirm" />
                </td>
                <td class="text-xs-center" style="min-width: 100px">
                  <template v-if="indexLoading === props.index">
                    <v-progress-circular
                      :size="20"
                      indeterminate
                      color="primary"
                    />
                  </template>
                  <template
                    v-else-if="
                      props.item.type != 'fan' && canManage(props.item)
                    "
                  >
                    <v-icon
                      color="success"
                      class="mr-1"
                      @click="openForm(props.item, index)"
                    >
                      edit
                    </v-icon>
                    <button-confirm
                      v-if="!props.item.confirm"
                      color="primary"
                      small
                      flat
                      icon="check"
                      :text="$t('action.buttons.confirmRole')"
                      @submit="_enrole(props.item, props.index)"
                    />
                    <button-confirm
                      color="error"
                      small
                      flat
                      :icon="props.item.confirm ? 'delete' : 'close'"
                      :text="
                        props.item.confirm
                          ? $t('action.buttons.deleteRole')
                          : $t('action.buttons.rejectRole')
                      "
                      @submit="
                        _enrole(
                          props.item,
                          props.index,
                          true,
                          props.item.confirm
                        )
                      "
                    />
                  </template>
                  <span v-else>--</span>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-user-role
      v-model="dialog"
      :user-id="id"
      :role="role"
      :type-role="typeRole"
      :entity-id="entityId"
      @unrole="_enrole(role, index, true, role.confirm)"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogUserRole from './roles/DialogUserRole'

export default {
  name: 'StepRoles',
  components: { DialogUserRole },
  props: {
    id: { type: String },
    entityId: {
      type: String,
    },
    typeRole: {
      type: String,
    },
  },
  data() {
    return {
      match: '',
      indexLoading: '',
      dialog: false,
      loading: false,
      role: null,
      index: null,
    }
  },
  // created() {
  //   this.init()
  // },
  computed: {
    ...mapState({
      userRoles: (state) => state.users.userRoles,
    }),
    formatUserRoles() {
      return this.userRoles
        .filter((role) => role.type !== 'fan')
        .map((role) => {
          let text = []
          role.objects.forEach((object) => text.push(object.name))
          return { ...role, text }
        })
    },
    headers() {
      let headers = [
        {
          text: this.$tc('models.role'),
          value: 'role',
        },
        {
          text: `${this.$tc('models.entity')} / ${this.$tc(
            'models.team'
          )} / ${this.$tc('titles.global.player')} / ${this.$tc(
            'models.tournament'
          )} `,
          sortable: false,
          value: 'text',
        },

        {
          text: this.$t('fields.tournaments.confirmed'),
          value: 'confirm',
          align: 'center',
        },
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
      ]

      return headers
    },
  },
  methods: {
    ...mapActions({
      fetchUserRoles: 'users/fetchUserRoles',
      enrole: 'users/enrole',
    }),
    init() {
      if (this.id) {
        this.loading = true
        this.fetchUserRoles(this.id).finally(() => {
          this.loading = false
        })
      }
    },
    _enrole(userRole, index, unrole = false, force) {
      this.indexLoading = index
      let payload = {
        userId: this.id,
        userRoleId: userRole._id,
        unrole,
        view: 'user',
        force,
      }

      this.enrole(payload).finally(() => {
        this.indexLoading = ''
      })
    },
    openForm(role, index) {
      this.role = role
      this.index = index
      this.dialog = true
    },
    canManage(role) {
      if (this.isAdmin) return true

      let entityId = 'entityId'
      let teamId = 'teamId'

      if (role.objects && role.objects.length) {
        switch (role.type) {
          case 'coordinator':
            entityId = role.objects[0]._id

            break
          case 'trainer':
          case 'player':
            teamId = role.objects[0]._id
            entityId = role.objects[0].entityId
            break
          case 'familiar':
            if (role.objects[0].teams && role.objects[0].teams.length) {
              teamId = role.objects[0].teams[0]._id
              entityId = role.objects[0].teams[0].entityId
            }
            break
          default:
            break
        }
      }
      return (
        this.is(['president', 'coordinator'], entityId) ||
        this.is('trainer', teamId)
      )
    },
  },
}
</script>
<style>
.role-item > .v-list__tile--avatar {
  height: auto;
}
</style>
